document.addEventListener('DOMContentLoaded', () => {
	const projects = document.querySelectorAll<HTMLElement>('[data-project]');
	let selectedProjectTypes: string[] = [];
	selectedProjectTypes = [];

	const filterButtons = document.querySelectorAll<HTMLElement>(
		'[data-filter-button]',
	);

	const resetButton = document.querySelector<HTMLElement>(
		'[data-reset-button]',
	);

	const clearButton = (filterButton) => {
		filterButton.classList.remove('filter__button--active');
		filterButton.setAttribute('aria-pressed', 'false');
		checkFilter();
	};

	const deactivateButton = (button) => {
		button.classList.remove('filter__button--active');
		button.setAttribute('aria-pressed', 'false');
	};

	const activateButton = (filterButton) => {
		deactivateButton(resetButton);
		filterButton.classList.add('filter__button--active');
		filterButton.setAttribute('aria-pressed', 'true');
	};

	const resetButtons = (buttons, filterButton) => {
		buttons.forEach((button) => {
			if (button !== filterButton) {
				deactivateButton(button);
			}
		});
	};

	const resetFilter = () => {
		projects.forEach((project) => {
			project.style.removeProperty('display');
		});

		activateButton(resetButton);
		selectedProjectTypes = [];
	};

	const checkFilter = () => {
		projects.forEach((project) => {
			const projectType = project.getAttribute('data-project-type');

			if (!projectType) {
				project.style.display = 'none';
				return;
			} else {
				const projectTypeArray = projectType?.split(',');

				const matchesProjectType = selectedProjectTypes.every((type) =>
					projectTypeArray.includes(type),
				);

				if (matchesProjectType) {
					project.style.removeProperty('display');
				} else {
					project.style.display = 'none';
				}
			}
		});
	};

	filterButtons.forEach((filterButton) => {
		filterButton.addEventListener('click', () => {
			let status = filterButton.getAttribute('aria-pressed');

			const projectType = filterButton.getAttribute('data-filter-button');
			if (!projectType) return;

			if (projectType === 'all') {
				resetFilter();
				resetButtons(filterButtons, resetButton);
				return;
			}

			if (status === 'true') {
				selectedProjectTypes = selectedProjectTypes.filter((type) => {
					return type != projectType;
				});
				clearButton(filterButton);
				if (selectedProjectTypes.length === 0) {
					resetFilter();
				}
				return;
			} else {
				selectedProjectTypes.push(projectType);
				activateButton(filterButton);
			}
			checkFilter();
		});
	});
});
